import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import style from './newtab.module.scss'

export const NewTab = ({ linkNewTab }) => {
  return (
    <Element
      className={style.newTab}
      style={{
        fontSize: 14,
        fontWeight: 300,
        borderRadius: 8,
      }}
      onClick={() => window.open(linkNewTab)}
    >
      <Translate value="library.main.OPEN_TAB" />
    </Element>
  )
}
